import request from '../helpers/request'

export default {
  quickOrder: async formData => {
    const { data } = await request.post('/shop/one-click/buy/', formData)

    return data
  }
}
